import { render, staticRenderFns } from "./OrganisationNavbar.vue?vue&type=template&id=80290c46&"
import script from "./OrganisationNavbar.vue?vue&type=script&lang=js&"
export * from "./OrganisationNavbar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports